/* eslint-disable no-useless-escape */
export const buildMatomoTagsScript = (src) => `
      var _mtm = (window._mtm = window._mtm || []);
      _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
      (function () {
        var d = document,
          g = d.createElement("script"),
          s = d.getElementsByTagName("script")[0];
        g.async = true;
        g.src = '${src}';
        s.parentNode.insertBefore(g, s);
      })();`;
export const buildMatomoAnalyticsScript = (u) => `
   var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(["setCookieDomain", "*.platform.moex.com"]);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u='${u}';
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '1']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();`;
export const getMotomoFeatureFlag = async ({ featureFlags, }) => {
    const featureFlagName = "enableMatomoAnalytics";
    return featureFlags.find((flag) => flag?.name === featureFlagName);
};
export const initMatomoTagManager = ({ MATOMO_TAG_MANAGER_URL }) => {
    if (!MATOMO_TAG_MANAGER_URL)
        return;
    const script = document.createElement("script");
    script.setAttribute("id", "matomo-tag-manager");
    script.innerHTML = buildMatomoTagsScript(MATOMO_TAG_MANAGER_URL);
    document.head.appendChild(script);
};
export const initMatomoAnalytics = ({ MATOMO_ANALYTICS_URL }) => {
    if (!MATOMO_ANALYTICS_URL)
        return;
    const script = document.createElement("script");
    script.setAttribute("id", "matomo-analytics");
    script.innerHTML = buildMatomoAnalyticsScript(MATOMO_ANALYTICS_URL);
    document.head.appendChild(script);
};
export const initAnalytics = async (context) => {
    const featureFlag = await getMotomoFeatureFlag(context);
    if (!featureFlag || !featureFlag?.value)
        return;
    initMatomoAnalytics(context?.configuration?.original);
    initMatomoTagManager(context?.configuration?.original);
};
